import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'tcc-fatal-error',
  templateUrl: './fatal-error-dialog.component.html',
  styleUrls: ['./fatal-error-dialog.component.scss']
})
export class FatalErrorDialogComponent {

  _jsonData: string;
  _encodedData: string;


  @ViewChild('encoded') _encodedElement: ElementRef;


  constructor(public _dialogRef: MatDialogRef<FatalErrorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public _data: any) {
    // Create json string from data
    this._jsonData = JSON.stringify(_data, null, 4);

    // Base64 encode data
    this._encodedData = btoa(this._jsonData);
  }


  onEncodedClick() {
    this._encodedElement.nativeElement.select();

    document.execCommand('Copy');

    this.showCopiedNotification();
  }

  showCopiedNotification() {
    const encodedData = this._encodedData;

    this._encodedData = 'Kopiert!';

    setTimeout(() => {
      this._encodedData = encodedData;
    }, 3000);
  }

}
